require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-write-web-pages-in-one-language-instead-of-three.json") })
        }
      }, "path---blog-write-web-pages-in-one-language-instead-of-three");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-write-web-pages-in-one-language-instead-of-three!./.cache/json/blog-write-web-pages-in-one-language-instead-of-three.json
// module id = 1182
// module chunks = 231608221292675